import styled from "styled-components";

import UIButtonPrimary from "components/UI/Button/Primary";

export const Wrapper = styled.div`
  background: ${p => p.theme.colors.white};
  border: ${p => `1px solid ${p.theme.colors.iron}`};
  border-radius: 2px;
  box-shadow: 0 0 10px 0 rgba(109, 120, 129, 0.16);
  display: flex;
  flex: 1 0 1px;
  flex-direction: column;
  margin: 24px;
  position: relative;

  &:first-of-type {
    margin: 24px 24px 0;
  }
`;

export const Header = styled.header`
  align-items: center;
  border-bottom: ${p => `1px solid ${p.theme.colors.alto}`};
  display: flex;
  font-size: 14px;
  font-weight: 500;
  height: 69px;
  padding-left: 25px;
  text-transform: uppercase;
`;

export const VehicleSectionWrapper = styled.div`
  margin: 15px;
`;

export const MiscFeeSectionWrapper = styled.div`
  margin: 0px;
`;

export const Pre1981DataSectionWrapper = styled.div`
  margin: 0px;
`;

export const FieldsWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  padding: 0 0 15px 0;
`;

export const ButtonPrimary = styled(UIButtonPrimary)`
  margin: 15px 15px 0;
`;

export const MessageSection = styled.div`
  align-items: center;
  display: flex;
  font-size: 14px;
  font-weight: bold;
  padding-left: 20px;
  padding-bottom: 15px;
`;